import DatePicker, {defaultDateFormat} from '../../../common/DatePicker';
import SimpleDatePicker from "../../../common/SimpleDatePicker";

export default {
    id: 0,

    name: 'working_terms',
    _system: {
        name: 'Periods of Work',
        relatedTo: 'working_terms',
    },
    date_from: {
        label: "Date From",
        hideLabel: true,
        placeholder: 'Add Date From',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date_from',
            relatedTo: 'working_terms'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date_from',
        rules: {
            required: true,
            title: 'Date From field'
        },
        grid: {
            className: 'col col-6'
        }
    },
    date_to: {
        label: "Date To",
        hideLabel: true,
        placeholder: 'Add Date To',
        dateFormat: defaultDateFormat,
        utc: true,
        timeFormat: false,
        viewMode: 'days',
        system: {
            component: SimpleDatePicker,
            name: 'date_to',
            relatedTo: 'working_terms'
        },
        value: '',
        errors: [],
        type: 'text',
        name: 'date_to',
        rules: {
            title: 'Date To field'
        },
        grid: {
            className: 'col col-5'
        }
    }
};



// WEBPACK FOOTER //
// ./src/containers/Employee/fields/working_terms.js